/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Rigged(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0.25C1.48122 0.25 0.25 1.48122 0.25 3C0.25 4.25878 1.09575 5.32002 2.25 5.64648L2.25 14.3535C1.09575 14.68 0.25 15.7412 0.25 17C0.25 18.5188 1.48122 19.75 3 19.75C4.25878 19.75 5.32002 18.9043 5.64648 17.75H14.3535C14.68 18.9043 15.7412 19.75 17 19.75C18.5188 19.75 19.75 18.5188 19.75 17C19.75 15.7412 18.9043 14.68 17.75 14.3535L17.75 5.64648C18.9043 5.32002 19.75 4.25878 19.75 3C19.75 1.48122 18.5188 0.25 17 0.25C15.7412 0.25 14.68 1.09575 14.3535 2.25L5.64648 2.25C5.32002 1.09575 4.25878 0.25 3 0.25ZM5.64648 16.25H14.3535C14.4332 15.9682 14.5567 15.7047 14.7162 15.4675L7.61523 8.36523L4.53325 5.28325C4.29583 5.44299 4.03213 5.56669 3.75 5.64648L3.75 14.3535C4.66584 14.6125 5.38745 15.3342 5.64648 16.25ZM16.25 14.3535C16.1172 14.3911 15.9885 14.4384 15.8646 14.4946L9.3106 7.9394L9.31066 7.93934L8.67393 7.30261L8.03043 6.659L8.03038 6.65906L5.50582 4.1345C5.56185 4.01094 5.60901 3.8825 5.64648 3.75L14.3535 3.75C14.6125 4.66584 15.3342 5.38745 16.25 5.64648L16.25 14.3535ZM17 1.75C16.3096 1.75 15.75 2.30964 15.75 3C15.75 3.69036 16.3096 4.25 17 4.25C17.6904 4.25 18.25 3.69036 18.25 3C18.25 2.30964 17.6904 1.75 17 1.75ZM1.75 17C1.75 16.3096 2.30964 15.75 3 15.75C3.69036 15.75 4.25 16.3096 4.25 17C4.25 17.6904 3.69036 18.25 3 18.25C2.30964 18.25 1.75 17.6904 1.75 17Z"
        fill="currentColor"
      />
    </svg>
  )
}

Rigged.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Rigged
